// extracted by mini-css-extract-plugin
module.exports = {"Heading2":"QuizPage_Heading2__1bt3s"};